import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { ctaData } from '../mockData';
import { railsAPI } from '../services/api';
import { ArrowRight, Mail, Check } from 'lucide-react';
import { toast } from 'sonner';

const CTASection = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [joinFormData, setJoinFormData] = useState({
    name: '',
    email: '',
    profession: ''
  });

  const handleSessionSignup = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }

    setIsSubmitting(true);
    try {
      const result = await railsAPI.signUpForSession(email);
      if (result.success) {
        toast.success(result.message);
        setEmail('');
      }
    } catch (error) {
      toast.error(typeof error === 'string' ? error : 'Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleJoinSubmit = async (e) => {
    e.preventDefault();
    if (!joinFormData.name || !joinFormData.email) {
      toast.error('Please fill in all required fields');
      return;
    }

    setIsSubmitting(true);
    try {
      const result = await railsAPI.joinCommunity(joinFormData);
      if (result.success) {
        toast.success(result.message);
        setJoinFormData({ name: '', email: '', profession: '' });
      }
    } catch (error) {
      toast.error(typeof error === 'string' ? error : 'Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="cta-section">
      <div className="cta-container">
        {/* Primary CTA - Join Community */}
        <div id="cta-join" className="cta-card primary-cta">
          <div className="cta-content">
            <h2 className="cta-title">{ctaData.primary.title}</h2>
            <p className="cta-description">{ctaData.primary.description}</p>
            
            <form onSubmit={handleJoinSubmit} className="join-form">
              <div className="form-grid">
                <Input
                  type="text"
                  placeholder="Your Name"
                  value={joinFormData.name}
                  onChange={(e) => setJoinFormData({...joinFormData, name: e.target.value})}
                  className="form-input"
                />
                <Input
                  type="email"
                  placeholder="Your Email"
                  value={joinFormData.email}
                  onChange={(e) => setJoinFormData({...joinFormData, email: e.target.value})}
                  className="form-input"
                />
                <Input
                  type="text"
                  placeholder="Your Profession (Optional)"
                  value={joinFormData.profession}
                  onChange={(e) => setJoinFormData({...joinFormData, profession: e.target.value})}
                  className="form-input"
                />
              </div>
              
              <Button 
                type="submit" 
                className="cta-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Joining...' : ctaData.primary.buttonText}
                <ArrowRight size={20} />
              </Button>
            </form>

            <div className="cta-benefits">
              <div className="benefit-item">
                <Check size={18} />
                <span>Instant access to community</span>
              </div>
              <div className="benefit-item">
                <Check size={18} />
                <span>Free learning resources</span>
              </div>
              <div className="benefit-item">
                <Check size={18} />
                <span>Event notifications</span>
              </div>
            </div>
          </div>
        </div>

        {/* Secondary CTA - Sign Up for Session */}
        <div id="cta-session" className="cta-card secondary-cta">
          <div className="cta-icon">
            <Mail size={48} />
          </div>
          <h3 className="cta-subtitle">{ctaData.secondary.title}</h3>
          <p className="cta-subdescription">{ctaData.secondary.description}</p>
          
          <form onSubmit={handleSessionSignup} className="session-form">
            <div className="email-input-group">
              <Input
                type="email"
                placeholder={ctaData.secondary.placeholder}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="email-input"
              />
              <Button 
                type="submit" 
                className="email-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Submitting...' : ctaData.secondary.buttonText}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
